import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const FeatureBannerVariationSectionButtonSchema = z.object({
  url: z.string().optional().nullable(),
  text: z.string().optional().nullable(),
  download: z.boolean().optional().nullable(),
  target: z.enum(["_self", "_blank"]).optional().nullable()
});
const FeatureBannerVariationSectionSchema = z.object({
  data: z.object({
    id: z.string().optional().nullable(),
    title: z.string().optional().nullable(),
    button1: FeatureBannerVariationSectionButtonSchema.optional().nullable(),
    button2: FeatureBannerVariationSectionButtonSchema.optional().nullable(),
    backgroundImageMobile: z.string(),
    backgroundImageDesktop: z.string()
  }).merge(SectionSpacingSchema)
});
export default FeatureBannerVariationSectionSchema;
